<template>
  <div
    v-if="visible"
    id="modalGlobal"
    ref="inputField"
    :class="`tw-w-[97%] ${
      centered
        ? 'tw-z-[1071] tw-fixed top-of-modal tw-left-2/4 tw-translate-x-[-50%] tw-translate-y-[-50%]'
        : 'tw-relative'
    } tw-max-w-[1040px] tw-justify-center tw-items-center modal-wrapper  ${className} ${
      overflow ? 'modal-wrapper-profile' : ''
    }`"
  >
    <div
      :class="`tw-relative tw-bg-white lg:tw-overflow-y-hidden ${
        overflowYScroll ? '!tw-overflow-y-auto' : ''
      } ${
        overflowYVisible ? '!tw-overflow-y-visible' : ''
      } tw-w-full tw-flex tw-flex-col tw-rounded-[6px] tw-max-w-[100%] modal-main ${styleModal}`"
      :style="{
        borderRadius: borderRadius,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import _ from "underscore";
import { onBeforeUnmount, onMounted, watch, ref, computed } from "vue";
const inputField = ref(null);
let initialValue = {};
const emit = defineEmits(["close"]);

/**
 * Need get/set all initial "value" before "visible" = true
 * Because functions check close on click backdrop will not work.
 */
const props = defineProps({
  value: { type: Object, required: false, default: () => {} },
  visible: { type: Boolean, default: false },
  overlay: { type: Boolean, default: true },
  centered: { type: Boolean, default: true },
  className: { type: String, default: "" },
  closeOnBackdropClick: { type: Boolean, default: true },
  overflowYScroll: { type: Boolean, default: true },
  fieldFocus: { type: Object, required: false, default: () => {} },
  borderRadius: { type: String, default: "6px" },
  overflowYVisible: { type: Boolean, default: false },
  isHideOverlay: { type: Boolean, default: true },
  styleModal: { type: String, default: "" },
  closeOnEsc: { type: Boolean, default: true },
  overflow: { type: Boolean, default: false },
  shouldScrollToBottom: { type: Boolean, default: false },
});

const handleVisible = () => {
  if (!props.overlay) return;
  if (props.visible) {
    setTimeout(() => {
      const modal: any = document.getElementById("modalGlobal");
      const inputForm: any = document.getElementsByClassName("autoFocus");
      const isInsideModal = Array.from(inputForm).every((el) =>
        modal.contains(el),
      );
      if (
        inputForm &&
        inputForm.length > 0 &&
        !props.shouldScrollToBottom &&
        isInsideModal
      ) {
        inputForm[0].focus();
      }
    }, 100);

    initialValue = JSON.stringify(props.value);
    store.dispatch("Overlay/showOverlay");

    // Watch event when modal is visible.
    EventEmitter.on(EmitterEvents.EVENT_KEYBOARD_ESC, () => {
      if (props.closeOnEsc) emit("close");
    });
    EventEmitter.on(EmitterEvents.EVENT_SWITCH_ORG, () => emit("close"));

    // Only Watch if closeOnBackdropClick === TRUE.
    if (!props.closeOnBackdropClick) return;

    window.addEventListener("click", (e: any) => {
      if (
        _.isEqual(initialValue, JSON.stringify(props.value)) &&
        e.target.id === "globalOverlay"
      )
        emit("close");
    });
  } else {
    destroyModal();
  }
  setTimeout(() => {
    EventEmitter.emit("setZIndexIConNavBar", true);
    if (props.visible) {
      EventEmitter.emit("setZIndexIConNavBar", true);
    } else {
      EventEmitter.emit("setZIndexIConNavBar", false);
    }
  }, 0);
};

const destroyModal = () => {
  initialValue = {};
  if (props.isHideOverlay) {
    store.dispatch("Overlay/hideOverlay");
  }
  if (props.isHideOverlay) {
    EventEmitter.off(EmitterEvents.EVENT_KEYBOARD_ESC);
  }
  EventEmitter.off(EmitterEvents.EVENT_SWITCH_ORG);

  if (props.closeOnBackdropClick) window.removeEventListener("click", () => {});
};

const overflowYScrollModalMain = computed(() => {
  return props.overflowYScroll ? "auto" : "none";
});

onMounted(() => {
  handleVisible();
});
onBeforeUnmount(() => destroyModal());
watch(() => props.visible, handleVisible);
</script>

<style scoped lang="scss">
.modal-wrapper {
  max-height: calc(100vh - 150px);
  border-radius: 6px;

  .modal-main {
    // border: 1px solid #eff0f1;
    max-height: inherit;
    overflow: v-bind(overflowYScrollModalMain);
  }
}

.add-domain-modal .modal-main {
  border-radius: 6px;
}
@media only screen and (max-width: 1240px) {
  .modal-wrapper-profile {
    max-height: calc(100vh - 110px);
    border-radius: 6px;

    .modal-main {
      // border: 1px solid #eff0f1;
      max-height: inherit;
      overflow: auto;
    }
  }
}
.top-of-modal {
  top: calc(50vh + 27px);
}
.top-of-sub-modal {
  top: calc(50vh - 75px);
}
</style>
